<script lang="ts" setup>
import { useRoute } from "vue-router";
import { computed } from "vue";
import RightSideNav from "@/components/mobile/nav/RightSideNav.vue";

const route = useRoute();

const showRightSidebar = computed(() => !route.meta.layout?.hideRightSidebar);
</script>
<template>
  <main
    id="root-layout"
    class="w-full h-full mx-auto overflow-hidden lg:max-w-[600px] flex justify-items-stretch"
  >
    <!-- <SideNav class="justify-end shrink-0" /> -->
    <!--    <SidebarNavi />-->
    <div
      :class="{
        'xl:w-full': !showRightSidebar,
        'md:shrink-0': showRightSidebar,
      }"
      class="h-full overflow-hidden w-full sm:w-[600px] flex-grow"
    >
      <RouterView />
    </div>
    <!-- <RightSideNav v-if="showRightSidebar" /> -->
    <SideDrawerPopup />
  </main>
</template>
<style></style>
